var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container mx-auto px-2 lg:px-6 py-4 md:py-6"},[_c('Header'),_vm._v(" "),_c('br'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('br'),_vm._v(" "),_c('Nuxt')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }